module.exports = __webpack_public_path__ + "fonts/Marianne-Regular.6b76dc6.otf";